import React, { useContext, useEffect } from "react";

import GlobalConfig from "app/config/global";
import SessionContext from "app/contexts/SessionContext";
import Text from "shared/components/data-display/mui/Text";
import { useNavigate } from "react-router-dom";
import { Wrapper } from "./TimesheetsPage.styles";

const TimesheetsPage = () => {
    const session = useContext(SessionContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (!session.timesheetRequired && (session.freelancer || session.contractor)) {
            return;
        } else if (session.timesheetRequired) {
            navigate(`/timesheets/employee/${GlobalConfig.routes.timesheetGrid}`, { replace: true });
        } else {
            navigate(`/timesheets/employee/${globalThis.config.routes.timeOff}`, { replace: true });
        }
    }, [session, navigate]);

    if (!session.timesheetRequired && (session.freelancer || session.contractor)) {
        return (
            <Wrapper className="unauth-msg-wrapper">
                <Text variant="largeBold">You do not require to enter timesheets</Text>
                <Text variant="smallLight">
                    Reach out your manager if you have questions.
                </Text>
            </Wrapper>
        );
    }

    return null;
};

export default TimesheetsPage;
